import { config } from '@app/config';
import { BRAND_ASSETS_BASE, theme } from '@mi-front/ui';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: stretch;
  background: ${theme.blue};
  text-align: center;
  padding-top: 5rem;
  position: relative;
  background-size: cover;
  background-position: center center;
`;

const Logo = styled.img`
  width: 20rem;
  height: auto;
  margin: 4rem auto 0;
`;

const Description = styled.div`
  width: 28rem;
  margin: 3rem auto 5rem;
  font-size: 1.3rem;
  line-height: 2rem;
  color: white;
  text-shadow:
    0 0 8px 0 rgba(0, 0, 0, 0.12),
    0 8px 12px 0 rgba(0, 0, 0, 0.06);
`;

export function LoginIntro() {
  return (
    <Wrapper
      style={{
        background: `url(${BRAND_ASSETS_BASE}/images/radio-microphone.jpg)`,
      }}
    >
      <a
        href="https://mediainbox.net"
        target="_blank"
        rel="noopener noreferrer"
        style={{ display: 'block' }}
      >
        <Logo
          src={`${BRAND_ASSETS_BASE}/images/logo.png`}
          alt="MediaInbox logo"
          style={{
            filter: config.isAppDev ? 'hue-rotate(180deg) saturate(1.5)' : undefined,
          }}
        />
      </a>
      <Description>
        <FormattedMessage
          id="auth.loginScreen.intro"
          defaultMessage="Escucha, descarga y comparte fragmentos de tu emisión de radio o tv con tu equipo y tus oyentes utilizando una misma herramienta."
        />
      </Description>
      <Button
        component="a"
        href="mailto:contact@mediainbox.net"
        variant="contained"
        size="large"
        sx={{
          maxWidth: '30rem',
          mx: 'auto',
          backgroundColor: '#08ecb8',
          color: 'rgba(0, 0, 0, 0.87)',
          '&:hover': { backgroundColor: '#06d4a3' },
          fontSize: '1.1rem',
          textTransform: 'none !important',
          fontWeight: 400,
        }}
      >
        <FormattedMessage
          id="auth.loginScreen.contactBtn"
          defaultMessage="Contáctanos para más información"
        />
      </Button>
    </Wrapper>
  );
}
